import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';
import { LayoutContent } from '../../../components/Layout';
import TitleBlock from '../../../components/EditComponents/TitleBlock';

const StepLayout = ({ header, title, subtitle, children }) => (
  <>
    {header && <LayoutContent>{header}</LayoutContent>}
    <Divider />
    <LayoutContent>
      <TitleBlock title={title} subtitle={subtitle} />
      <div style={{ paddingTop: 9 }}>{children}</div>
    </LayoutContent>
  </>
);

StepLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

export default memo(StepLayout);
